import React from "react";
import { Button, Modal } from "antd";

const PrivacyPolicyModal = ({ open, onClose }) => {
  return (
    <Modal
      title="Privacy Policy"
      open={open}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          Close
        </Button>,
      ]}
      width={800}
      centered
    >
      <div
        style={{
          maxHeight: "65vh",
          overflowY: "auto",
          paddingRight: "12px",
          fontSize: "15px",
          lineHeight: "1.6",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "24px" }}>
          BajCan Privacy Policy
        </h2>

        <p
          style={{
            fontStyle: "italic",
            textAlign: "center",
            marginBottom: "32px",
          }}
        >
          Effective Date: March 10, 2026
        </p>

        <p>
          Welcome to BajCan. Your privacy is important to us. This Privacy
          Policy explains how BajCan collects, uses, stores, and protects your
          personal information when you use our website, mobile applications,
          and remittance services.
        </p>
        <p>
          This policy applies to all users of BajCan services in Canada,
          Barbados, and other supported destinations.
        </p>

        <h3>1. Who We Are</h3>
        <p>
          BajCan is a remittance platform designed to connect individuals in
          Canada with recipients in Barbados and other Caribbean destinations.
          Our services allow users to send money securely to family, friends,
          and businesses.
        </p>
        <p>For privacy-related questions you may contact us at:</p>
        <ul>
          <li>
            <strong>Privacy Officer</strong>
          </li>
          <li>BajCan</li>
          <li>
            Email: <a href="mailto:info@bajcan.com">info@bajcan.com</a>
          </li>
          <li>
            Website:{" "}
            <a
              href="https://www.bajcan.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.bajcan.com
            </a>
          </li>
        </ul>

        <h3>2. Information We Collect</h3>
        <p>
          To provide secure remittance services, BajCan collects certain
          personal and financial information.
        </p>

        <strong>Personal Identification Information</strong>
        <p>This may include:</p>
        <ul>
          <li>Full name</li>
          <li>Date of birth</li>
          <li>Address</li>
          <li>Phone number</li>
          <li>Email address</li>
          <li>Government-issued identification</li>
          <li>Selfie or identity verification images</li>
        </ul>
        <p>
          These details may be required to comply with Know Your Customer (KYC)
          and financial regulations.
        </p>

        <strong>Financial Information</strong>
        <p>When you use BajCan to send money, we may collect:</p>
        <ul>
          <li>Bank account details</li>
          <li>Payment card information</li>
          <li>Transaction history</li>
          <li>Recipient details</li>
          <li>Amounts transferred</li>
          <li>Currency information</li>
        </ul>
        <p>
          Payment information may be processed through licensed financial
          partners.
        </p>

        <strong>Device and Technical Information</strong>
        <p>When using our website or apps we may collect:</p>
        <ul>
          <li>Device type</li>
          <li>IP address</li>
          <li>Operating system</li>
          <li>Browser type</li>
          <li>App usage data</li>
          <li>Log files</li>
        </ul>
        <p>
          This information helps us maintain security and improve service
          performance.
        </p>

        <strong>Communication Information</strong>
        <p>If you contact BajCan support, we may collect:</p>
        <ul>
          <li>Customer service messages</li>
          <li>Email correspondence</li>
          <li>Chat support transcripts</li>
          <li>Call recordings (if applicable)</li>
        </ul>

        <h3>3. How We Use Your Information</h3>
        <p>BajCan uses your information to operate and improve our services.</p>
        <p>We may use your data to:</p>
        <ul>
          <li>Process and complete remittance transactions</li>
          <li>Verify identity and comply with financial regulations</li>
          <li>Prevent fraud and financial crime</li>
          <li>Provide customer support</li>
          <li>Improve website and mobile app functionality</li>
          <li>Notify users of service updates</li>
          <li>Comply with legal and regulatory obligations</li>
        </ul>
        <p>
          <strong>We do not sell your personal information.</strong>
        </p>

        <h3>4. Compliance with Financial Regulations</h3>
        <p>
          As a financial service provider, BajCan must comply with regulations
          related to anti-money laundering and fraud prevention.
        </p>
        <p>This may require:</p>
        <ul>
          <li>Identity verification</li>
          <li>Monitoring of transactions</li>
          <li>
            Reporting suspicious activity to relevant authorities where required
            by law
          </li>
        </ul>
        <p>
          Users may be asked to provide additional documentation to complete
          transactions.
        </p>

        <h3>5. Sharing Your Information</h3>
        <p>
          BajCan may share information with trusted partners only when necessary
          to operate our services.
        </p>
        <p>This may include:</p>
        <ul>
          <li>Payment processors</li>
          <li>Banking partners</li>
          <li>Identity verification providers</li>
          <li>Regulatory authorities</li>
          <li>Fraud detection services</li>
        </ul>
        <p>
          All partners are required to maintain strict confidentiality and data
          protection standards.
        </p>

        <h3>6. Data Security</h3>
        <p>
          BajCan uses industry-standard security practices to protect your
          information.
        </p>
        <p>These include:</p>
        <ul>
          <li>Secure encryption of sensitive data</li>
          <li>Access controls for internal systems</li>
          <li>Fraud monitoring tools</li>
          <li>Secure payment processing systems</li>
        </ul>
        <p>
          While we take strong measures to protect data, no online system can
          be guaranteed to be completely secure.
        </p>

        <h3>7. Data Retention</h3>
        <p>We retain personal information only as long as necessary to:</p>
        <ul>
          <li>Provide services</li>
          <li>Meet legal and regulatory requirements</li>
          <li>Resolve disputes</li>
          <li>Prevent fraud</li>
        </ul>
        <p>
          Financial services may require records to be retained for several
          years under regulatory requirements.
        </p>

        <h3>8. Your Privacy Rights</h3>
        <p>Depending on your location, you may have the right to:</p>
        <ul>
          <li>Request access to your personal information</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of certain data</li>
          <li>Withdraw consent for optional data uses</li>
        </ul>
        <p>Requests may be submitted by contacting our Privacy Officer.</p>

        <h3>9. Cookies and Website Tracking</h3>
        <p>
          BajCan may use cookies and analytics tools to improve the user
          experience.
        </p>
        <p>Cookies help us:</p>
        <ul>
          <li>Understand website traffic</li>
          <li>Improve navigation</li>
          <li>Maintain secure sessions</li>
        </ul>
        <p>Users may disable cookies through their browser settings.</p>

        <h3>10. International Data Transfers</h3>
        <p>
          Because BajCan operates across multiple jurisdictions, personal
          information may be processed or stored in Canada or other regions
          where our service partners operate.
        </p>
        <p>All such transfers follow appropriate data protection safeguards.</p>

        <h3>11. Updates to This Policy</h3>
        <p>
          BajCan may update this Privacy Policy periodically to reflect service
          or regulatory changes.
        </p>
        <p>Updated policies will be posted on our website and app.</p>

        <h3>12. Contact Us</h3>
        <p>If you have questions about this Privacy Policy, please contact:</p>
        <ul>
          <li>
            <strong>Privacy Officer</strong>
          </li>
          <li>BajCan</li>
          <li>
            Email: <a href="mailto:info@bajcan.com">info@bajcan.com</a>
          </li>
        </ul>

        <p
          style={{
            marginTop: "32px",
            fontSize: "14px",
            color: "#555",
          }}
        >
          Thank you for trusting BajCan with your information.
        </p>
      </div>
    </Modal>
  );
};

export default PrivacyPolicyModal;
